import script from "./CompanyApplicantCardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyApplicantCardItem.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__